import IdleJs from "idle-js";
import { api, getCurrentToken, isSwitched } from '/@src/services/api.service.js';
import { sendHeartbeat } from "../services/heartbeat.service";

export class IdleManager {
  constructor() {
    this.idle = null;
    this.heartbeatInterval = null;
    this.sessionId = this.getTabSessionId();
    this.browserId = this.getBrowserId();

    // Set default headers for tab ID only
    api.defaults.headers.common['X-Wa-Tab-Id'] = this.sessionId;
    api.defaults.headers.common['X-Browser-Id'] = this.browserId;
  }

  getBrowserId() {
    let browserId = localStorage.getItem('browser_id');

    if (!browserId) {
      browserId = `${crypto.randomUUID()}`;
      localStorage.setItem('browser_id', browserId);
    }

    return browserId;
  }

  getTabSessionId() {
    let tabSessionId = sessionStorage.getItem('tab_session_id');

    if (!tabSessionId) {
      tabSessionId = `${crypto.randomUUID()}`;
      sessionStorage.setItem('tab_session_id', tabSessionId);

      this.registerTab(tabSessionId);
    }

    return tabSessionId;
  }

  registerTab(tabSessionId) {
    const tabs = this.safeParseTabs();
    tabs[tabSessionId] = {
      lastActive: Date.now(),
      browserId: this.browserId
    };
    localStorage.setItem('user_tabs', JSON.stringify(tabs));
  }

  safeParseTabs() {
    try {
        return JSON.parse(localStorage.getItem('user_tabs')) || {};
    } catch {
        return {};
    }
  }

  cleanupTab() {
    const tabs = this.safeParseTabs();
    delete tabs[this.sessionId];
    localStorage.setItem('user_tabs', JSON.stringify(tabs));
  }

  initialize() {
    if (getCurrentToken() && !isSwitched()) {
      window.addEventListener('beforeunload', () => {
        this.cleanupTab();
      });

      this.initIdle();
    }
  }

  initIdle() {
    this.idle = new IdleJs({
      idle: 5 * 60 * 1000, // 5 minutes idle time
      events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'touchmove'],
      onIdle: () => {
        this.stopHeartbeat();
        this.sendHeartbeat(true);
      },
      onActive: () => {
        this.sendHeartbeat(false); // false = active
        this.startHeartbeat();
      },
      keepTracking: true,
      startAtIdle: false,
    })

    this.idle.start();

    // Send initial heartbeat right away
    this.sendHeartbeat(this.idle.idle);

    if (!this.idle.idle) {
      this.startHeartbeat();
    }
  }

  sendHeartbeat(isIdle = false) {
    sendHeartbeat(isIdle)
      .catch(error => {
        console.error("Error sending heartbeat:", error);
      });

    const tabs = this.safeParseTabs();
    if (tabs[this.sessionId]) {
        tabs[this.sessionId].lastActive = Date.now();
        tabs[this.sessionId].browserId = this.browserId;
        localStorage.setItem('user_tabs', JSON.stringify(tabs));
    }
  }

  startHeartbeat() {
    if (this.heartbeatInterval) return;

    this.heartbeatInterval = setInterval(() => {
        this.sendHeartbeat(false);
    }, 30 * 1000); // every 30 seconds
  }

  stopHeartbeat() {
    if (this.heartbeatInterval) {
        clearInterval(this.heartbeatInterval);
        this.heartbeatInterval = null;
    }
  }

  stop() {
    if (this.idle) {
      this.idle.stop();
      this.idle = null;
    }
    this.stopHeartbeat();
    this.cleanupTab();
  }
}

export const idleManager = new IdleManager();
